import { FiSend, FiEdit3, FiImage } from "react-icons/fi";
import styles from "../../styles/home.module.css";
import customDesignImage from "../../assets/customDesign.jpeg";

const CustomDesignSection = ({ onStart }) => {
  return (
    <section className={styles.section}>
      <div className={styles.custom}>
        <div className={styles.customArt}>
          <img src={customDesignImage} alt="أدوات تصميم لوحة خط عربي مخصصة" className={styles.customImage} loading="lazy" />
        </div>

        <div className={styles.customBody}>
          <h2>صمّم لوحتك الخاصة</h2>

          <div className={styles.customIcons}>
            <FiSend />
            <FiEdit3 />
            <FiImage />
          </div>

          <p className={styles.customText}>
            حوّل فكرتك إلى لوحة فريدة تعبّر عن ذوقك — نرافقكم خطوة بخطوة لتكون
            لوحتكم قطعة واحدة لا تشبه أي لوحة أخرى
          </p>

          <button type="button" onClick={onStart} className={styles.cta}>
            ابدأ تصميمك الآن
          </button>
        </div>
      </div>
    </section>
  );
};

export default CustomDesignSection;
